import { h } from 'preact'
import { Post } from './index'
import UserAvatar from '../User/UserAvatar'
import TopicReplyCount from '../ui-components/TopicReplyCount'
import TopicViewsCount from '../ui-components/TopicViewsCount'
import ClampLines from 'react-clamp-lines'

interface FeaturedTopicView {
  title: string
  url: string
  featuredImage: string
  label: string
  replyCount: number
  views: number
  fullWidth: boolean
  post: Post
  customClass: string
}

const FeaturedTopicView = ({ title, url, featuredImage, label, replyCount, views, fullWidth, post, customClass = '' }: FeaturedTopicView) => (
  <li class={`featured-topic ${fullWidth ? 'featured-topic--full-width' : ''} ${featuredImage && 'featured-topic--featured-image'} ${customClass}`}>
    <a href={url} class='featured-topic__url'>
      <div>
        {label &&
          <span class='topic__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'>
            {label}
          </span>
        }
        {featuredImage &&
          <div class='featured-topic__hero' style={{ backgroundImage: `url(${featuredImage})` }} />
        }
      </div>
      <div class="featured-topic__title">
        <h3 class={`featured-topic__heading ${!featuredImage && label ? 'featured-topic__heading--no-image' : ''}`}>{title}</h3>
        {window.inSidedData?.device !== 'mobile' && (fullWidth || !featuredImage) &&
          <p class='text--meta'>
            <ClampLines lines={3} text={post.content} buttons={false} />
          </p>
        }
        <div class='post-meta__container'>
          <div class='post-meta__container--left'>
            <UserAvatar user={post.author} extraClass='avatar avatar--XS' />
            <span class='thread-meta-item__date'>
              {post.relativeCreationDate}
            </span>
          </div>
          <div class='post-meta__container--right'>
            <TopicViewsCount views={views} />
            <TopicReplyCount replyCount={replyCount} />
          </div>
        </div>
      </div>
    </a>
  </li>
)

export default FeaturedTopicView
